var sample_config = [
    {key:"pos",value:"POS"},
    {key:"chr",value:"#CHR"},
    {key:"ref",value:"REF"},
    {key:"alt",value:"ALT"},
    {key:"tracks",value:[
        {bb:"FINNGEN_pval",beta:"FINNGEN_beta",pip:undefined,af:"FINNGEN_af_alt"},
        {bb:"UKBB_pval",beta:"UKBB_beta",pip:undefined,af:"UKBB_af_alt"},
        {bb:"ESTBB_pval",beta:"ESTBB_beta",pip:undefined,af:"ESTBB_af_alt"},
        ]}
    ]

export default sample_config;